import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backendApi } from "../../api/apiService";
function CandidateInfo({ candidate, candidateInit, fieldDisableOrNot }) {
  console.log("Candidate:", candidate);
  console.log("Candidate Init Function:", candidateInit);
  console.log("Field Disable or Not:", fieldDisableOrNot);
  const [editedCandidate, setEditedCandidate] = useState({ ...candidate });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCandidate({ ...editedCandidate, [name]: value });
  };

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  }
  const updateProfile = () => {
    const regexPhoneNUmber =
      /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
    const regexEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
    if (editedCandidate.full_name === "") {
      toast.warn("Full Name Required", { containerId: "K" });
      return false;
    } else if (editedCandidate.email_id === "") {
      toast.warn("Email Id Required", { containerId: "K" });
      return false;
    } else if (!regexEmail.test(editedCandidate.email_id)) {
      toast.warn("Email Id Is Invalid", { containerId: "K" });
      return false;
    } else if (editedCandidate.mobile_no === "") {
      toast.warn("Mobile Number Required", { containerId: "K" });
      return false;
    } else if (!regexPhoneNUmber.test(editedCandidate.mobile_no)) {
      toast.warn("Mobile Number Is Invalid", { containerId: "K" });
      return false;
    } else if (editedCandidate.address === "") {
      toast.warn("Adress Required", {
        containerId: "K",
      });
      return false;
    }
    var req = {
      functionName: "candidateProfileUpdate",
      candidate_id: editedCandidate.id,
      full_name: editedCandidate.full_name,
      email_id: editedCandidate.email_id,
      mobile_no: editedCandidate.mobile_no,
      address: editedCandidate.address,
    };
    backendApi(req).then((response) => {
      if (response.success === "1") {
        toast.success("Profile Updated succesfully", { containerId: "K" });
        setTimeout(() => {
          candidateInit();
        }, 1000);
      } else {
        toast.warn("Something went wrong, please try again", {
          containerId: "K",
        });
      }
    });
  };
  return (
    <div className="cardDeatils">
      <ToastContainer
        enableMultiContainer
        containerId={"K"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="dash-sub-head" style={{ fontSize: "18px" }}>
        Candidate Details
      </div>
      <div className="row mt-3">
        <div className="col-xl-4 col-lg-6">
          <div className="row align-items-center">
            <label class="col-lg-4 col-form-label">Name :</label>
            <div class="col-lg-8">{editedCandidate.full_name}</div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="row  align-items-center">
            <label class="col-lg-4 col-form-label">Email Id :</label>
            <div class="col-lg-8">{editedCandidate.email_id}</div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="row  align-items-center">
            <label class="col-lg-4 col-form-label">Uploaded On:</label>
            <div class="col-lg-8">
              {formatDateToCustomFormat(editedCandidate.created_on)}
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="row  align-items-center">
            <label class="col-lg-4 col-form-label">Mobile No :</label>
            <div class="col-lg-8">{editedCandidate.mobile_no}</div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="row  align-items-center">
            <label class="col-lg-4 col-form-label">Address :</label>
            <div class="col-lg-8">{editedCandidate.address}</div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-6">
          <div className="row  align-items-center">
            <label class="col-lg-4 col-form-label">Referral Id:</label>
            <div class="col-lg-8">{editedCandidate.employee_referal_id}</div>
          </div>
        </div>
        {/* {!fieldDisableOrNot ? (
          <div className="col-md-12">
            <div className="childIssueses">
              <a
                className="btn-btn btn btn-btn2 btn-sm me-2"
                onClick={(e) => updateProfile()}
              >
                Update
              </a>
              <a
                className="btn-btn btn btn-btn1 btn-sm"
                onClick={(e) => setEditedCandidate({ ...candidate })}
              >
                Reset
              </a>
            </div>
          </div>
        ) : (
          ""
        )} */}
      </div>
    </div>
  );
}
export default CandidateInfo;
